<template>
  <div>
    <div class="admin_title" style="position: relative">考题小分类管理 <router-link :to="{path: prefix + '/org/examQClassification_f/' + this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id}" class="class_back_top">返回</router-link></div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <span class="name_f_span">当前大分类: {{name_f}}</span>
      <a href="javascript:;" @click="relate(selectedValArr)">关联大分类</a>
    </div>
    <div class="add_shijuan_con mmHeight">
      <table id="customers">
        <tr>
          <th width="15%">
            <input type='checkbox' :checked="(selectedValArr.length === list.length) && list.length != 0" @click='checkedAll()' style="opacity: 1">
          </th>
          <th width="70%">小分类名称</th>
          <th width="15%">排序</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>
            <input type="checkbox" :checked="selectedValArr.indexOf(item.middleType)>=0" @click='checkedOne(item.middleType)' style="opacity: 1"/>
          </td>
          <td>{{item.middleTypeLabel}}</td>
          <td>暂无排序</td>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

  export default {
    components: {},
    data () {
      return {
        list: [],
        selectedList: [],
        pages: 0,
        cnt: 0,

        name_f: '',
        name: '',
        name_sort: '0',

        selectedValArr: [],
        isCheckedAll: false,
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.name_f = this.$route.params.fLabel
      this.val_f = this.$route.params.fValue
    },
    mounted () {
      this.getClassifications()
    },
    computed: {},
    methods: {
      getClassifications () {
        this.selectedIdArr = []
        this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: this.val_f, middleType: 'examMiddleType', select: '0'}, r => {
          if (r.data && r.data.length>0) {
            this.list = r.data
          }
          this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: this.val_f, middleType: 'examMiddleType', select: '1'}, r => {
            if (r.data && r.data.length>0) {
              this.selectedList = r.data
              for (let i=0; i<this.selectedList.length; i++) {
                this.selectedValArr.push(this.selectedList[i].middleType)
              }
            }
          })
        })
      },
      checkedOne (val) {
        let valIndex = this.selectedValArr.indexOf(val)
        if (valIndex >= 0) {
          this.selectedValArr.splice(valIndex, 1)
        } else {
          this.selectedValArr.push(val)
        }
      },
      checkedAll () {
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          this.selectedValArr = []
          if (this.list.length>0) {
            for (let i = 0; i<this.list.length; i++) {
              this.selectedValArr.push(this.list[i].middleType)
            }
          }
        } else {
          this.selectedValArr = []
        }
      },
      relate (valArr) {
        let valStr = ''
        if (valArr && valArr.length > 0) {
          for (let i = 0; i<valArr.length; i++) {
            if (i < valArr.length-1) {
              valStr += valArr[i] + ','
            } else if (i == valArr.length-1) {
              valStr += valArr[i]
            }
          }
        }
        this.$api.post(this.$global.examApiPath, '/examTypeRel/save', {largeType: this.val_f, middleType: valStr}, r => {
          this.$router.push({path: this.prefix + '/org/examQClassification_f/'+ this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id})
          // this.$router.push({path: '/org/examClassification_s/'+ this.$utils.URLencode(this.$route.params.path) + '/'  + this.$route.params.id})
        })
      },
      goBack () {
        this.$router.push({path: this.prefix + '/org/examQClassification_f/'+ this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id})
      }
    }
  }
</script>
<style lang="scss">
  .name_f_span{display:inline-block; margin-left:16px; margin-top:9px;}
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/classification_relate.vue